import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";

const getCountries = {
    namespaced: true,
    state: {
        countries: [],
    },
    mutations: {
        GET_COUNTRIES_SUCCESS(state, response) {
            state.countries = response.data.data;
        },
        GET_COUNTRIES_FAILURE(state, error) {
            console.log(error);
        }
    },
    actions: {
        getCountriesRequest: function({ dispatch }) {
            let promise = sendRequest("get", config.baseURLApi + "/getCountries");
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCountries", result[1]);
                } else {
                    dispatch("failureGetCountries", result[1]);
                }
            });
        },
        successGetCountries: function({ commit }, response) {
            commit("GET_COUNTRIES_SUCCESS", response);
        },
        failureGetCountries: function({ commit }, error) {
            commit("GET_COUNTRIES_FAILURE", error);
        }
    }
}

export default getCountries;